import lodashCompact from 'lodash/fp/compact';
import { anonymousUtilityUser } from 'client/constants';

import { SR_API_ACTION_UTILITY_PARTNER_SIGNUP } from 'api/utilityActionTypes';

import { hasRolePartner, hasRoleAnonymous } from 'common/utility/userRoles';

import loadCurrentUtilityPartnerAction from 'client/actions/UtilityPartner/loadCurrentUtilityPartner';

export async function onLogicSuccess({ state, utilityApiClient, user }) {
  const currentUser = { ...anonymousUtilityUser, ...user };

  await Promise.all(
    lodashCompact([
      hasRolePartner(user.roles) &&
        user.utilityPartnerId &&
        loadCurrentUtilityPartnerAction({ state, utilityApiClient }, { id: user.utilityPartnerId }),
    ]),
  );

  state.set('utilityUser', currentUser);
}

export default async function partnerSignup({ state, history, utilityApiClient }, payload) {
  const utilityUser = state.get(['utilityUser']);

  await utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_SIGNUP,
    state: state,
    payload,
    async onSuccess({ partner, user }) {
      // An admin user is signing up a partner
      if (!hasRoleAnonymous(utilityUser.roles)) {
        history.replace(`/utility-profit/${partner.slug}`);
        return;
      }

      await onLogicSuccess({
        state,
        utilityApiClient,
        user,
      });
    },
  });
}
